






















import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, IOS14QuotaType, IOS14Type } from '@tt4b/ttam-enums';
import Ios14Switch from './index';
import { CreateMode } from '@ad/tt_ads_common_enums';
import { useSelectedApp } from './../../hooks/creation/adgroup/useSelectedApp/index';

const name = 'ttam-ios14-switch-compose';
export default defineComponent({
  name,
  components: {
    TtamIos14SwitchContainer: Ios14Switch.TtamIos14SwitchContainer,
    TtamIos14SwitchEncourageInfo: Ios14Switch.TtamIos14SwitchEncourageInfo,
    TtamIos14SwitchAppProfilePage: Ios14Switch.TtamIos14SwitchAppProfilePage,
    TtamIos14SwitchQuotaAlert: Ios14Switch.TtamIos14SwitchQuotaAlert,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, createMode } = toRefs(props);

    const { isPermittedApp, isFrozenApp, eventManagerUrl } = useSelectedApp({
      adgroupData,
    });

    const { isIOS14Disabled } = Ios14Switch.usePropsIos14Disabled({
      campaignData,
      adgroupData,
    });

    const { disabledIos14Hint } = Ios14Switch.usePropsIos14DisabledHint({
      campaignData,
    });

    const { disabledProfilePage } = Ios14Switch.usePropsProfilePageDisabled({
      createMode,
      campaignData,
    });

    const { ios14Quota } = Ios14Switch.usePropsIos14Quota({
      campaignData,
      adgroupData,
    });

    const { quotaType } = Ios14Switch.usePropsQuotaType(ios14Quota);

    const { quotaDescription } = Ios14Switch.usePropsQuotaDesc(ios14Quota);

    const { quotaTitle } = Ios14Switch.usePropsQuotaTitle(ios14Quota);

    const appProfilePageType = computed({
      get: () => adgroupData.value.adAppProfilePageType,
      set: val => {
        emit('change', {
          adAppProfilePageType: val,
        });
      },
    });

    const { appProfilePageVisible } = Ios14Switch.usePropsAppProfilePageVisible({
      adgroupData,
    });

    const { encourageInfoVisible } = Ios14Switch.usePropsEncourageInfoVisible({
      adgroupData,
    });

    const { quotaAlertVisible } = Ios14Switch.usePropsQuotaAlertVisible({
      adgroupData,
      isFrozenApp,
    });
    const openIos14 = computed({
      get: () => adgroupData.value.targetDeviceVersion === IOS14Type.ABOVE,
      set: val => {
        emit('change', {
          targetDeviceVersion: val ? IOS14Type.ABOVE : IOS14Type.UNSET,
          ios14QuotaType: val ? IOS14QuotaType.OCCUPIED : IOS14QuotaType.UNOCCUPIED,
        });
      },
    });

    return {
      name,
      openIos14,
      isIOS14Disabled,
      disabledIos14Hint,
      disabledProfilePage,
      appProfilePageType,
      appProfilePageVisible,
      encourageInfoVisible,
      quotaAlertVisible,
      quotaType,
      quotaDescription,
      quotaTitle,
      isPermittedApp,
      eventManagerUrl,
    };
  },
});
